import { gql } from '@apollo/client';

// Public queries and mutations for appointments
export const SERVICES_QUERY = gql`
    query Services($active: Boolean) {
        services(active: $active) {
            uuid
            name
            description
            durationMinutes
            price
            active
            species
            bufferBeforeMinutes
            bufferAfterMinutes
        }
    }
`;

export const BOOK_SERVICE_MUTATION = gql`
    mutation BookService($input: BookServiceInput!) {
        bookService(input: $input) {
            uuid
            serviceUuid
            staffUuid
            animalId
            startAt
            endAt
            price
            status
            notes
        }
    }
`;
